export enum ToastActions {
  Upload = "upload",
  Create = "create",
  MoveToBin = "move-to-bin",
  Rename = "rename",
  Move = "move",
  Generic = "generic",
  Link = "link",
  Remove = "remove",
  Share = "share",
  Download = "download",
  UpdateFileSets = "update-file-sets"
}